import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import search from '../../../../common/assets/icons/search.svg';
import styles from './FieldInvoice.module.scss';

const FieldInvoice = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'invoices-form-invoiceNumber',
    defaultMessage: 'Invoice number'
  });
  const [field, meta] = useField({name: 'invoiceID'});

  return (
    <div className={styles.searchContainer}>
      <InputText
        {...field}
        {...meta}
        variant={'full'}
        id={field.name}
        placeholder={labelText}
        defaultValue={field.value}
        customClassnames={{
          container: styles.customContainer,
          input: styles.customInput
        }}
      />
      <img
        src={search}
        alt="search"
        className={styles.searchIcon}
      />
    </div>
  );
};

export default FieldInvoice;
